import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "./pages/Landing";
import Logistics from "./pages/Logistics";
import Trading from "./pages/Trading";
import { useEffect } from "react";

function ScrollToHash() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);

      if (element) {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: "smooth",
          });
        }, 100);
      }
    }
  }, [hash]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/logistics" element={<Logistics />} />
          <Route path="/trading" element={<Trading />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;